<template>
  <v-card>
    <v-form @submit.prevent="true" autocomplete="off">
      <v-container style="padding-top: 15px; padding-bottom: 0px">
        <v-row>
          <v-col cols="6">
            <v-text-field
              required
              variant="underlined"
              :rules="NameRules"
              label="Task"
              v-model="task.name"
              auto-grow
              :readonly="readonly"
              :error-messages="taskNameMessages"
            ></v-text-field>
            <v-select
              label="Required in order to"
              variant="underlined"
              item-title="value"
              item-value="key"
              v-model="task.taskListType"
              :items="TaskListTypes"
              required
              :readonly="readonly"
              :error-messages="taskTypeErrors"
              return-object
            ></v-select>
            <v-select
              label="Related Change Type"
              variant="underlined"
              item-title="value"
              item-value="key"
              :readonly="readonly"
              v-model="task.relatedChangeType"
              :items="RelatedChangeTypes"
              required
              :error-messages="relatedChangeTypeErrors"
            ></v-select>
            <people-picker
              :readonly="readonly"
              :user="task.owner"
              v-model="task.owner"
              label="Task Owner"
              @clear="task.owner = null"
            ></people-picker>
            <v-text-field
              :error-messages="stepErrors"
              variant="underlined"
              type="number"
              placeholder="Type number"
              label="Step"
              :readonly="readonly"
              v-model="task.step"
            ></v-text-field>
            <people-picker
              :user="task.assignedTo"
              v-model="task.assignedTo"
              label="Assigned to"
              :readonly="readonly"
              :includeDistroService="true"
              @clear="task.assignedTo = null"
            ></people-picker>

            <v-row>
              <v-col cols="12">
                <label>Supporting Links ({{ task.supportingLinks ? task.supportingLinks.length : 0 }})</label>
                <a v-if="!readonly" style="padding-left: 15px" class="black-link" @click="addSupportingLink"
                  >Add supporting link</a
                >
              </v-col>
            </v-row>
            <v-row style="padding-bottom: 8px" v-bind:key="item.clientId" v-for="item in task.supportingLinks">
              <!-- had colum attribute -->
              <v-col cols="5" class="py-0">
                <v-text-field :readonly="readonly" v-model="item.url" label="URL"></v-text-field>
              </v-col>
              <v-col cols="5" class="py-0">
                <v-text-field :readonly="readonly" v-model="item.name" label="Name"></v-text-field>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-btn v-if="!readonly" @click="deleteSupportLinks(item)" icon fab small>
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label>Documented Information Link ({{ task.standards ? task.standards.length : 0 }})</label>
                <a v-if="!readonly" style="padding-left: 15px" class="black-link" @click="addStandard"
                  >Add documented information</a
                >
              </v-col>
            </v-row>
            <v-row style="padding-bottom: 8px" v-bind:key="item.clientId" v-for="item in task.standards"
              ><!-- had column -->
              <v-col cols="5" class="py-0">
                <v-text-field :readonly="readonly" v-model="item.url" label="URL"></v-text-field>
              </v-col>
              <v-col cols="5" class="py-0">
                <v-text-field :readonly="readonly" v-model="item.name" label="Name"></v-text-field>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-btn v-if="!readonly" @click="deleteStandard(item)" icon fab small>
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <label>Possible Responses</label>
            <a v-if="!readonly" style="padding-left: 15px" class="black-link" @click="addStatus">Add possible responses</a>
            <p class="error--text v-messages mt-1" v-if="typeof itemStatusMessage === 'string'">{{ itemStatusMessage }}</p>
            <v-row v-if="task.itemStatus && task.itemStatus.length > 0">
              <v-col cols="5">Response</v-col>
              <v-col cols="2">Task Satisfied</v-col>
              <v-col cols="2">Display Order</v-col>
            </v-row>
            <v-row justify="center" v-bind:key="item.clientId" v-for="(item, index) in task.itemStatus">
              <v-col cols="5" class="py-0">
                <v-text-field
                  :readonly="readonly"
                  variant="underlined"
                  required
                  v-model="item.name"
                  :error-messages="itemStatusNameMessages(index)"
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-checkbox
                  required
                  :readonly="readonly"
                  :error-messages="itemMustBeSatisfied()"
                  v-model="item.required"
                ></v-checkbox>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-text-field
                  required
                  variant="underlined"
                  :readonly="readonly"
                  :error-messages="itemStatusDisplayOrderMessages(index)"
                  v-model="item.displayOrder"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-btn v-if="!readonly" @click="deleteItemStatus(item)" icon fab small>
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  :items="operationalReadinessOptions"
                  variant="underlined"
                  item-value="code"
                  item-title="label"
                  :readonly="readonly"
                  :error-messages="operationalReadinessMessages"
                  label="Operational Readiness Inspection"
                  v-model="task.operationalReadinessInspection"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <TaskReviewDate :readonly="readonly" v-model="task.taskReviewDate" :value="task.taskReviewDate"></TaskReviewDate>
              </v-col>
            </v-row>
            <v-textarea
              :readonly="readonly"
              variant="underlined"
              v-model="task.taskReviewNotes"
              label="Task Review Notes"
              placeholder="Type notes"
            ></v-textarea>

            <v-checkbox :readonly="readonly" label="Active" v-model="task.active"></v-checkbox>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="end">
            <v-btn v-if="!readonly" :disabled="!valid()" color="success" @click="save()">Save</v-btn>
            <v-btn @click="close">Close</v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import TaskReviewDate from '@/components/TaskReviewDatePicker'
import { TaskListTypes, ChangeTypes } from '@/common/types'
export default {
  name: 'Task',
  data: () => ({
    expanded: false,
    minimumNameLength: 1,
    maximumNameLength: 500,
    minimumTranslationLength: 1,
    maximumTranslationLength: 300,
    tempApprovers: [],
    tempFyis: [],
    operationalReadinessOptions: [{ label: '', code: '0' }, { label: 'Yes', code: '1' }, { label: 'No', code: '2' }],
    TaskListTypes: Object.values(TaskListTypes.properties).filter(x => x.key !== 'all'),
    RelatedChangeTypes: Object.values(ChangeTypes.properties)
  }),
  methods: {
    addSupportingLink() {
      if (!this.task.supportingLinks) {
        this.task.supportingLinks = []
      }
      let newLink = {
        url: '',
        name: '',
        clientId: new Date().getTime()
      }
      this.task.supportingLinks.push(newLink)
    },
    addStandard() {
      if (!this.task.standards) {
        this.task.standards = []
      }
      let newLink = {
        url: '',
        name: '',
        clientId: new Date().getTime()
      }
      this.task.standards.push(newLink)
    },
    addStatus() {
      if (!this.task.itemStatus) {
        this.task.itemStatus = []
      }
      let newStatus = {
        name: '',
        required: false,
        clientId: new Date().getTime(),
        displayOrder: ''
      }
      this.task.itemStatus.push(newStatus)
    },
    save: function() {
      if ((this.task.supportingLinks || []).length > 0) {
        this.task.supportingLinks.forEach(t => {
          t.url = t.url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
        })
      }
      this.$emit('saveTask', this.task)
    },
    close: function() {
      this.$emit('closeTask')
    },
    deleteTask: function() {
      this.$emit('deleteTask', this.task)
    },
    valid: function() {
      if (!this.task.name) {
        return false
      }
      if (this.task.taskListType == null) {
        return false
      }

      if (this.task.relatedChangeType == null) {
        return false
      }

      if (this.task.step == null) {
        return false
      }
      if (!this.task.itemStatus || this.task.itemStatus.length <= 0) {
        return false
      }

      if (this.task.itemStatus && this.task.itemStatus.find(it => !it.name || (!it.displayOrder && it.displayOrder !== 0))) {
        return false
      }

      if (this.task.itemStatus && this.task.itemStatus.every(it => !it.required)) {
        return false
      }

      if (this.task.operationalReadinessInspection == null || this.task.operationalReadinessInspection === '0') {
        return false
      }

      return true
    },
    itemMustBeSatisfied() {
if (this.task.itemStatus && this.task.itemStatus.every(it => !it.required)) {
       return 'One satisfactory response is required.'
      }
      return null
    },
    itemStatusNameMessages(index) {
      return !this.task.itemStatus[index].name ? 'Required' : null
    },
    itemStatusDisplayOrderMessages(index) {
      return !this.task.itemStatus[index].displayOrder && this.task.itemStatus[index].displayOrder !== 0 ? 'Required' : null
    },
    deleteSupportLinks(item) {
      this.task.supportingLinks = this.task.supportingLinks.filter(
        i => (i.id ? i.id : i.clientId) !== (item.id ? item.id : item.clientId)
      )
    },
    deleteStandard(item) {
      this.task.standards = this.task.standards.filter(i => (i.id ? i.id : i.clientId) !== (item.id ? item.id : item.clientId))
    },
    deleteItemStatus(item) {
      this.task.itemStatus = this.task.itemStatus.filter(i => (i.id ? i.id : i.clientId) !== (item.id ? item.id : item.clientId))
    }
  },
  computed: {
    taskTypeErrors: {
      get: function() {
        return this.task.taskListType == null ? 'Required in order to is required' : null
      }
    },
    relatedChangeTypeErrors: {
      get: function() {
        return this.task.relatedChangeType == null ? 'Related change type is required' : null
      }
    },
    stepErrors() {
      if (!this.task.step) return 'Step is required'
      return null
    },
    operationalReadinessMessages() {
      return !this.task.operationalReadinessInspection ? 'Operational Readiness Inspection is required' : null
    },
    itemStatusMessage() {
      return !this.task.itemStatus || this.task.itemStatus.length <= 0 ? 'At least one possible response is required' : false
    },
    taskNameMessages() {
      return !this.task.name ? 'Task is required' : null
    },
    NameRules: {
      get: function() {
        return [
          v => !!v || 'Task is required',
          v => (v && v.trim().length >= this.minimumNameLength) || `Minimum length is ${this.minimumNameLength}`,
          v => (v && v.trim().length <= this.maximumNameLength) || `Maximum length is ${this.maximumNameLength}`
        ]
      }
    }
  },
  props: {
    task: Object,
    readonly: Boolean
  },
  components: {
    PeoplePicker,
    TaskReviewDate
  }
}
</script>
<style scoped>

.black-link {
  color: #000000;
  text-decoration:underline;

}

</style>
